import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useGetLeaveReqAdminList } from "../../hooks/useManagement";
import { MiladiToShamsi } from "../../utils/Miladi_To_Shamsi";
import Button from "../Button/Button";
import { LeaveReqItemModal } from "../Dialog/LeaveReqItemModal";
import Loading from "../Loadings/LoadingTable";
import { Table } from "../Table/Table";
import Typography from "../Typography/Typography";
import { LeaveReqAdminStyle } from "./LeaveReqAdminStyle";

const LeaveReqAdmin = () => {
  const [Search, setSearch] = useState("");
  const [show, setShow] = useState(false);
  const [item, setItem] = useState();
  const { data: LeaveReqAdminList, isLoading } = useGetLeaveReqAdminList();
  const navigate = useNavigate();
  const RollCallHeader = [
    "شماره",
    "نام و نام خانوادگی",
    "توضیحات",
    "تاریخ",
    "وضعیت درخواست",
    "نظر سرپرست",
    "وضعیت برای سرپرست",
    "نظر مدیر",
    "وضعیت برای مدیر",
  ];
  const items = LeaveReqAdminList?.data?.data?.map((item, index) => {
    return (
      <tr
        key={index}
        onClick={() => {
          setShow(true);
          setItem(item);
        }}
      >
        <td>
          <span className="text-muted fw-bold text-muted d-block fs-7">
            {index + 1}
          </span>
        </td>
        <td>
          <span className="text-muted fw-bold text-muted d-block fs-7">
            <span>
              {(item?.FirstName ? item?.FirstName : "") +
                " " +
                (item?.LastName ? item?.LastName : "")}
            </span>
          </span>
        </td>
        <td>
          <span className="text-muted fw-bold text-muted d-block fs-7">
            {item?.Description}
          </span>
        </td>
        <td>
          <span className="text-muted fw-bold text-muted d-block fs-7">
            {`از تاریخ ${MiladiToShamsi(item?.StartDate)} ساعت ${
              item?.StartHours
            } تا تاریخ ${MiladiToShamsi(item?.EndDate)} ساعت ${item?.EndHours}`}
          </span>
        </td>

        <td>
          <span className="text-muted fw-bold text-muted d-block fs-7">
            <Button
              small="fit-content"
              bgColor={item?.main_status?.color}
              color="#fff"
            >
              {item?.main_status?.title}
            </Button>
          </span>
        </td>

        <td>
          <span className="text-muted fw-bold text-muted d-block fs-7">
            {item?.DescriptionResponsible
              ? item?.DescriptionResponsible
              : "نامشخص"}
          </span>
        </td>
        <td>
          <span className="text-muted fw-bold text-muted d-block fs-7">
            <span className={`text-muted fw-bold text-muted d-block fs-7`}>
              <Button
                small="fit-content"
                bgColor={item?.responsible_status?.color}
                color="#fff"
              >
                {item?.responsible_status?.title}
              </Button>
            </span>
          </span>
        </td>

        <td>
          <span className="text-muted fw-bold text-muted d-block fs-7">
            {item?.DescriptionAdmin ? item?.DescriptionAdmin : "نامشخص"}
          </span>
        </td>
        <td>
          <span className="text-muted fw-bold text-muted d-block fs-7">
            <Button
              bgColor={item?.admin_status?.color}
              color="#fff"
              small="fit-content"
            >
              {item?.admin_status?.title}
            </Button>
          </span>
        </td>
      </tr>
    );
  });
  return (
    <LeaveReqAdminStyle>
      <Table
        className="mt-3"
        setSearch={setSearch}
        headerTitle={RollCallHeader}
        items={!isLoading ? items : <Loading />}
        title={`لیست درخواست مرخصی`}
      />
      <LeaveReqItemModal
        show={show}
        handleClose={() => setShow(false)}
        item={item}
      />
    </LeaveReqAdminStyle>
  );
};

export default LeaveReqAdmin;
